import React from 'react';
import { Eyebrow, Section } from './Section';
import { pains } from '../data/pains';
export function PainGrid() {
  return <Section tone="paper" labelledBy="situations-title" data-id="element-152" data-mp="1zgq8qmugvxb7">
      <div className="grid grid-cols-1 gap-12 lg:grid-cols-12" data-id="element-153" data-mp="1uogo9mc4fpgb">
        <div className="lg:col-span-5" data-id="element-154" data-mp="1umvqzoyf9ser">
          <Eyebrow data-id="element-155" data-mp="1qnn14v6i6eoh">Les situations familières</Eyebrow>
          <h2 id="situations-title" className="max-w-prose font-serif text-3xl font-semibold leading-[1.15] text-graphite md:text-[2.5rem]" data-id="element-156" data-mp="1qmv6bmkqckz9">
            Si vous accompagnez des clients — ou si vous venez d’être
            certifié(e) — au moins une de ces situations vous parlera
          </h2>
          <p className="mt-8 max-w-prose font-serif text-lg italic leading-relaxed text-warm" data-id="element-157" data-mp="17o9587p7qtvc">
            Et si chacune de ces situations avait déjà sa réponse — séance par
            séance, fiche par fiche ?
          </p>
        </div>

        <ul className="divide-y divide-warm-line border-y border-warm-line lg:col-span-7" data-id="element-158" data-mp="323bldesdgzll">
          {pains.map(pain => <li key={pain} className="flex gap-4 py-5" data-id="element-159" data-mp="3g7s7u4y8wj0c">
              <span aria-hidden="true" className="mt-2 h-px w-6 shrink-0 bg-warm-line" data-id="element-160" data-mp="3l8g7tg4gca6p" />
              <p className="text-base leading-relaxed text-graphite-mid" data-id="element-161" data-mp="37a848pcwuamk">
                {pain}
              </p>
            </li>)}
        </ul>
      </div>
    </Section>;
}